import React, { useState } from 'react';

const DeleteConfirmationModal = ({ isOpen, lead, onConfirm, onCancel }) => {
    const [confirmText, setConfirmText] = useState('');

    if (!isOpen || !lead) return null;

    const isConfirmEnabled = confirmText === lead.company;

    const handleConfirm = () => {
        if (isConfirmEnabled) {
            onConfirm(confirmText);
            setConfirmText('');
        }
    };

    const handleCancel = () => {
        setConfirmText('');
        onCancel();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
                {/* Red warning header */}
                <div className="bg-red-600 text-white px-6 py-4 rounded-t-lg">
                    <h2 className="text-xl font-bold">Delete Client Permanently</h2>
                </div>

                <div className="p-6">
                    {/* Warning message */}
                    <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
                        <p className="text-red-800 font-medium">
                            This action cannot be undone. All data associated with this client will be permanently deleted.
                        </p>
                    </div>

                    {/* Client details */}
                    <div className="mb-4">
                        <p className="text-gray-700">
                            You are about to delete:
                        </p>
                        <p className="font-bold text-lg mt-1">{lead.company}</p>
                        <p className="text-gray-600">{lead.name} ({lead.email})</p>
                    </div>

                    {/* This will delete */}
                    <div className="mb-4 text-sm text-gray-600">
                        <p className="font-medium mb-1">This will delete:</p>
                        <ul className="list-disc list-inside">
                            <li>All Cognito user accounts</li>
                            <li>Project and all settings</li>
                            <li>All tasks and subtasks</li>
                            <li>All comments</li>
                            <li>All wiki pages</li>
                            <li>All team members</li>
                            <li>All risks and issues</li>
                        </ul>
                    </div>

                    {/* Confirmation input */}
                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Type <span className="font-bold">{lead.company}</span> to confirm:
                        </label>
                        <input
                            type="text"
                            value={confirmText}
                            onChange={(e) => setConfirmText(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                            placeholder="Type company name here"
                            autoFocus
                        />
                    </div>

                    {/* Buttons */}
                    <div className="flex justify-end space-x-3">
                        <button
                            onClick={handleCancel}
                            className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleConfirm}
                            disabled={!isConfirmEnabled}
                            className={`px-4 py-2 rounded-lg font-medium ${
                                isConfirmEnabled
                                    ? 'bg-red-600 text-white hover:bg-red-700'
                                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            }`}
                        >
                            Delete Permanently
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;
